import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { info } from 'console';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { LogoNames } from 'src/app/shared/enums/logoNames.enum';
import { KTUtil } from '../../../../../assets/js/components/util';
import KTLayoutHeader from '../../../../../assets/js/layout/base/header';
import KTLayoutHeaderMenu from '../../../../../assets/js/layout/base/header-menu';
import { LayoutService } from '../../../../RefModules/_metronic/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-cdms-header',
    standalone: false,
    // standalone: true,
    // imports: [],
    templateUrl: './cdms-header.component.html',
    styleUrl: './cdms-header.component.scss',
})
export class CdmsHeaderComponent implements OnInit, OnDestroy {
    @ViewChild('ktHeaderMenu', { static: true }) ktHeaderMenu: ElementRef;

    plantManagerSubscription: Subscription;
    CA = LogoNames.CA;
    headerContainerCSSClasses: string = '';
    headerMenuSelfDisplay: boolean;
    headerMenuSelfStatic: boolean;
    asideSelfDisplay: boolean;
    headerLogo: string;
    headerSelfTheme: string;
    headerMenuCSSClasses: string = '';
    headerMenuHTMLAttributes: any = {};
    routerLoaderTimout: any;
    ulCSSClasses: string = '';
    rootArrowEnabled: boolean;
    location: Location;
    headerMenuDesktopToggle: string;
    display = 'none';
    loader$: Observable<number>;
    isCompetencyModule: boolean;
    isCompetencyDashboard: boolean;
    isCompetencyPersonnel: boolean;
    isCompetencyEnrollments: boolean;
    isReports: boolean = false;
    siteSearchView: boolean;

    searchFormGroup: FormGroup;

    private loaderSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

    constructor(
        private layout: LayoutService,
        private router: Router,
        private userUtilityService: UserUtilityService,
        private cd: ChangeDetectorRef,
        private modalService: NgbModal,
        private fb: FormBuilder,
        private route: ActivatedRoute
    ) {
        this.loader$ = this.loaderSubject;
        // page progress bar percentage
        const routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                // set page progress bar loading to start on NavigationStart event router
                this.loaderSubject.next(10);
            }
            if (event instanceof RouteConfigLoadStart) {
                this.loaderSubject.next(65);
            }
            if (event instanceof RouteConfigLoadEnd) {
                this.loaderSubject.next(90);
            }
            if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
                // set page progress bar loading to end on NavigationEnd event router
                this.loaderSubject.next(100);
                if (this.routerLoaderTimout) {
                    clearTimeout(this.routerLoaderTimout);
                }
                this.routerLoaderTimout = setTimeout(() => {
                    this.loaderSubject.next(0);
                }, 300);
            }
        });
        this.unsubscribe.push(routerSubscription);
        this.isCompetencyModule = false;
    }

    async ngOnInit(): Promise<void> {
        // this.isCompetency = true;
        this.isCompetencyModule = await this.userUtilityService.checkUserPermissionDataAndRoute('competencymodule', userActions.View);
        this.isCompetencyDashboard = await this.userUtilityService.checkUserPermissionDataAndRoute('cdms-Dashboard', userActions.View);
        this.isCompetencyPersonnel = await this.userUtilityService.checkUserPermissionDataAndRoute('personnel', userActions.View);
        this.isCompetencyEnrollments = await this.userUtilityService.checkUserPermissionDataAndRoute('cdms-Enrollments', userActions.View);
        this.isReports = await this.userUtilityService.checkUserPermissionDataAndRoute('reports', userActions.View);
        this.siteSearchView = await this.userUtilityService.checkUserPermissionDataAndRoute('search', userActions.View);

        this.headerContainerCSSClasses = this.layout.getStringCSSClasses('header_container');
        this.headerMenuSelfDisplay = this.layout.getProp('header.menu.self.display');
        this.asideSelfDisplay = this.layout.getProp('aside.self.display');
        this.headerMenuSelfStatic = this.layout.getProp('header.menu.self.static');
        this.headerSelfTheme = this.layout.getProp('header.self.theme') || '';
        this.headerLogo = this.getLogoURL();
        this.headerMenuCSSClasses = this.layout.getStringCSSClasses('header_menu');
        this.headerMenuHTMLAttributes = this.layout.getHTMLAttributes('header_menu');
        this.ulCSSClasses = this.layout.getStringCSSClasses('header_menu_nav');
        this.rootArrowEnabled = this.layout.getProp('header.menu.self.rootArrow');
        this.headerMenuDesktopToggle = this.layout.getProp('header.menu.desktop.toggle');

        this.searchFormGroup = this.fb.group({
            searchText: [''],
            searchType: ['all'],
        });

        this.searchFormGroup.get('searchType').valueChanges.subscribe((value) => {
            if (value) {
                if (this.searchFormGroup.get('searchText')?.value?.length >= 3) {
                    this.router.navigate(['/idms/search'], {
                        queryParams: { keyword: this.searchFormGroup.get('searchText').value, type: this.searchFormGroup.get('searchType').value },
                    });
                } else {
                    this.searchFormGroup.get('searchText')?.setValue(' ');
                }
            }
        });
        this.route.queryParamMap.subscribe((params) => {
            if (params) {
                params.get('keyword') ? this.searchFormGroup.get('searchText').setValue(params.get('keyword')) : '';
                params.get('type') ? this.searchFormGroup.get('searchType').setValue(params.get('type')) : '';
            }
        });
    }

    private getLogoURL(): string {
        let result = 'logo-light.png';
        if (this.headerSelfTheme && this.headerSelfTheme === 'light') {
            result = 'logo-dark.png';
        }

        if (this.headerSelfTheme && this.headerSelfTheme === 'dark') {
            result = 'logo-dark.png';
        }
        return `./assets/media/logos/${result}`;
    }

    ngAfterViewInit(): void {
        if (this.ktHeaderMenu) {
            for (const key in this.headerMenuHTMLAttributes) {
                if (this.headerMenuHTMLAttributes.hasOwnProperty(key)) {
                    this.ktHeaderMenu.nativeElement.attributes[key] = this.headerMenuHTMLAttributes[key];
                }
            }
        }

        KTUtil.ready(() => {
            KTLayoutHeader.init('kt_header', 'kt_header_mobile');

            KTLayoutHeaderMenu.init('kt_header_menu', 'kt_header_menu_wrapper');
        });
    }

    searchedItemClick() {
        let searchedItem = this.searchFormGroup.get('searchText')?.value;
        if (searchedItem.length < 3) {
            // this.customToastService.warningToast('Your search needs to be at least 3 characters long.', 'Warning');
        } else if (searchedItem.length >= 3) {
            this.router.navigate(['/idms/search'], {
                queryParams: { keyword: searchedItem, type: this.searchFormGroup.get('searchType').value },
            });
        }
    }

    FetchBarcode() {}

    ngOnDestroy() {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
        if (this.routerLoaderTimout) {
            clearTimeout(this.routerLoaderTimout);
        }
        if (this.plantManagerSubscription) {
            this.plantManagerSubscription.unsubscribe();
        }
    }
}
